import React from "react";
import { ModeRendererProps } from "./types";

export function CircuitMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill="url(#traces)" />
      {Array.from({ length: 40 }).map((_, i) => (
        <circle key={i} cx={20 + ((i * 19) % 794)} cy={80 + ((i * 43) % 1123)} r="2.2" fill={i % 2 ? brand.amber : brand.violet} opacity={0.7} />
      ))}
    </g>
  );
}
